import { FC, ReactElement, ReactNode, useMemo } from 'react';
import { ActionsContextProvider } from '../../context';
import { dumpJsxAsYaml } from '../../utils';
import { CustomViewPageMeta, CustomViewPages } from './pages';
import { extractIncludeFromCode, useCustomActions } from './utils';

type CustomViewPageMetadataType = {
  included: any[];
  getCodeAsYaml: () => string;
  pageId: string;
  meta: CustomViewPageMeta;
};

export const CustomViewPageMetadata: FC<{
  pageId: string;
  children: (metadata: CustomViewPageMetadataType) => ReactNode;
}> = ({ pageId, children }) => {
  const meta = CustomViewPages.getMetadata(pageId);
  const getCustomViewChildren = CustomViewPages.get(pageId);

  if (!meta || !getCustomViewChildren)
    throw new Error(`Could not find custom view with id ${pageId}`);

  const child = getCustomViewChildren();
  const included = extractIncludeFromCode(child as ReactElement, '', '');
  const realActions = useCustomActions(pageId, included);

  const enrichedMetadata = useMemo(
    () => ({
      included,
      getCodeAsYaml: () => dumpJsxAsYaml(child),
      pageId: pageId,
      meta,
    }),
    [child, included, pageId, meta],
  );

  return (
    <ActionsContextProvider actions={realActions}>
      {children(enrichedMetadata)}
    </ActionsContextProvider>
  );
};
